export const mallOrderItemStateEnum = [
    {
        stateId: "UNPAID",
        stateName: "待付款"
    },
    {
        stateId: "NORMAL",
        stateName: "已支付"
    },
    {
        stateId: "AVAILABLE",
        stateName: "待使用"
    },
    {
        stateId: "COMPLETED",
        stateName: "已完成"
    },
    {
        stateId: "REFUNDED",
        stateName: "已退款"
    },
    {
        stateId: "PARTIAL_REFUNDED",
        stateName: "部分退款"
    }
]
